import { Component, ViewChild } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/messaging';
import 'firebase/firestore';
import * as moment from 'moment';

// produção
firebase.initializeApp({
  apiKey: "AIzaSyA4o_8jp29UJkxPkdXTkbM5ucvbZhiHec8",
  authDomain: "luizantoniodelivery.firebaseapp.com",
  databaseURL: "https://luizantoniodelivery.firebaseio.com",
  projectId: "luizantoniodelivery",
  storageBucket: "luizantoniodelivery.appspot.com",
  messagingSenderId: "168588835910",
  appId: "1:168588835910:web:38e33977229478aea91e47",
  measurementId: "G-023E67XFHJ"
});

//dev
// firebase.initializeApp({
//   apiKey: "AIzaSyCaxohni2Khk_yduz16Yj5EM_zSzhwueTU",
//   authDomain: "dev-ladelivery.firebaseapp.com",
//   databaseURL: "https://dev-ladelivery.firebaseio.com",
//   projectId: "dev-ladelivery",
//   storageBucket: "dev-ladelivery.appspot.com",
//   messagingSenderId: "501820281651",
//   appId: "1:501820281651:web:05fdd842b32d6f965ee446"
// });

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  from;
  to;
  ordersTotal;
  thisMonth = {
    total: 0,
    billing: 0,
    expired: 0,
    refused: 0,
    delivered: 0
  };
  seeBilling = false;

  @ViewChild('thisMonthModal') thisMonthModal;

  constructor() {
    // this.configNotifications();
    
    this.from = moment().startOf('month').toISOString().split('T')[0];
    this.to = moment().toISOString().split('T')[0];
    
    firebase.auth().onAuthStateChanged(() => {
      if (!firebase.auth().currentUser) return;
      firebase.firestore().collection('store').doc(firebase.auth().currentUser.uid).collection('orders')
      .where('moment', '>=', moment(this.from).startOf('day').toISOString())
      .where('moment', '<=', moment(this.to).endOf('day').toISOString())
      .get()
      .then(orders => {
        this.thisMonth.total = orders.docs.length;
        orders.docs.map(order => {
          if (order.data().status == 'finished' || order.data().status == 'received') {
            this.thisMonth.delivered++
            this.thisMonth.billing += order.data().total;
          }
          if (order.data().status == 'expired') this.thisMonth.expired++;
          if (order.data().status == 'refused') this.thisMonth.refused++;
        });
        this.thisMonthModal.show();
      });
    });

    
  }

  configNotifications() {
    const messaging = firebase.messaging();
    messaging.requestPermission().then(() => {
      return messaging.getToken().then(token => {
        firebase.auth().onAuthStateChanged(() => {
          if (firebase.auth().currentUser) {
            firebase.firestore().collection('store').doc(firebase.auth().currentUser.uid).update({token});
          }
        });
      });
    }).catch(e => {
      console.log(e);
    });
    messaging.onMessage(message => {
      console.log(message);
      alert(message);
    });
  }

  toBrazilianReals(value) {
    return 'R$ ' + parseFloat(value).toFixed(2).replace('.', ',');
  }


}
